import { Component } from '@angular/core';

@Component({
  selector: 'ui-fixed-bar',
  templateUrl: './fixed-bar.component.html'
})
export class FixedBarComponent {
}